export function getMetaTags(metaTags, enableBazzarV, srcLink) {
  if (!metaTags) {
    return {
      
    };
  }

  if (!enableBazzarV) {
    return {
      title: metaTags.title,
      meta: [
        {
          hid: "description",
          name: "description",
          content: metaTags.description,
        },
        // Add more meta tags as needed
      ],
    };
  } else {
    return {
      title: metaTags.title,
      meta: [
        {
          hid: "description",
          name: "description",
          content: metaTags.description,
        },
        // Add more meta tags as needed
      ],
      script: [
        {
          type: "text/javascript",
          id: "bvjs-filepath",
          async: true,
          src: srcLink,
        },
      ],
    };
  }
  
}
